import type { HTMLAttributes } from 'react';

import { cx } from '@/ui/classNames';

import styles from './Container.module.css';

export function Container({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx(styles.container, className)} {...props} />;
}
